import { useEffect, useState } from "react";
import { Remarkable } from "remarkable";
import {
  convertYouTubeLinksToPlainText,
  getVideoEmbedFromDescription,
} from "../../../../_components";
import AlertStrip from "../../../../_components/molecule/alert-strips";
import Label from "../../../../_components/typography/label.typography";
/**
 * Render lesson view content
 * @param {Object} lesson
 * @param {Boolean} isLoading - true if lesson is loading
 * @returns
 */

export function LessonSummaryView({ lesson, isLoading }) {
  const [videoUrl, setVideoUrl] = useState();

  const [description, setDescription] = useState("");

  /** Initialize videoUrl and description */
  useEffect(() => {
    if (lesson.coverMedia) {
      setVideoUrl(lesson.coverMedia);
    } else {
      setVideoUrl(null);
    }

    if (lesson.description) {
      const md = new Remarkable();
      const rawDescription = convertYouTubeLinksToPlainText(lesson.description);
      const renderedDescription = md.render(rawDescription);
      const descriptionWithEmbeds = getVideoEmbedFromDescription(
        renderedDescription ?? ""
      );
      setDescription(descriptionWithEmbeds ?? "");
    }
  }, [lesson]);

  if (isLoading) {
    return (
      <div className="h-(calc(100%-900px)) flex animate-pulse flex-col place-content-center gap-3 rounded bg-card p-4 py-2 pt-4">
        <div className="flex place-content-between items-center">
          <div className="h-8 w-5/12 bg-background" />
        </div>
        <div className="mt-4 h-32 w-7/12 bg-background"></div>
        <div className="h-96 bg-background" />
        <div className="bg-background" />
      </div>
    );
  }
  if (!lesson || Object.keys(lesson).length === 0) {
    return (
      <AlertStrip
        error
        title="No lesson found"
        message="Please select a lesson from the left panel."
        className="bg-card"
      />
    );
  }
  return (
    <div className="flex h-full flex-col space-y-2 rounded bg-card px-4 py-2">
      <div className="flex place-content-between items-center">
        <Label size="h3" variant="t2">
          {lesson.title}
        </Label>
      </div>
      <div className="flex flex-col">
        <div className="w-full">
          {videoUrl ? (
            <div className="group mt-4 h-80 w-full">
              <video
                className="aspect-video h-full w-full cursor-pointer rounded bg-background"
                controls
                src={videoUrl}
                controlsList="nodownload"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div
        className="NL2BR headings"
        dangerouslySetInnerHTML={{ __html: description }}></div>
    </div>
  );
}
